<template>
    <div>
        <rkm-table
            :fields="fields"
            :items="data.model.problemasFamiliares"
            hide-filters
            hide-pagination
        >
            <template v-slot:cell(info)="{index, item}">
                <div v-if="item.centroCusto">
                    <rkm-icon
                        :id="`problema-condicao-familiar-info-${index}`"
                        class="mr-2"
                        icon="info-circle"
                    />

                    <rkm-popover
                        :target="`problema-condicao-familiar-info-${index}`"
                        triggers="hover"
                    >
                        <div>{{item.centroCusto.setor.nome}}</div>
                        <div><rkm-icon icon="user" /> {{item.lotacao.profissional.nome}} - {{item.lotacao.ocupacao.nome}}</div>
                        <div><rkm-icon :icon="['far', 'clock']" /> {{item.dataHora}}</div>
                    </rkm-popover>

                    {{item.dataHora}}
                </div>
            </template>

            <template v-slot:cell(ciap)="{item}">
                {{`${item.ciap.codigo} - ${item.ciap.descricao}`}}
            </template>

            <template v-slot:cell(actions)="{index, item}">
                <rkm-button
                    @click="$refs.Modal.open(item)"
                    color="primary"
                    small
                    title="Editar"
                >
                    <rkm-icon icon="pen" />
                </rkm-button>

                <rkm-button
                    @click="destroy(index)"
                    color="danger"
                    small
                    title="Excluir"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>

        <Modal
            :data="data"
            ref="Modal"
        />
    </div>
</template>

<script>
// Components.
import Modal from './Modal'

export default {
    components: {Modal},
    data: () => ({
        fields: [
            {class: 'col-min', key: 'info', label: 'Data / Hora'},
            {key: 'ciap', label: 'CIAP 2', sortable: true},
            {class: 'col-min text-center', key: 'actions', label: 'Ações'},
        ],
    }),
    methods: {
        destroy(index) {
            this.showDeleteConfirmation('Deseja realmente excluir o problema do familiar?', async () => {
                this.data.model.problemasFamiliares.splice(index, 1)
            })
        },
    },
    props: {
        data: {type: Object, required: true},
    },
}
</script>